import {WriteFile} from '../../writer/message/WriteFile';
import {WriteSql} from '../../writer/message/WriteSql';

export class CnxWriter {
file: WriteFile;
kind: string;
sql: WriteSql;
syncMode: string;
}

